import { AgencyGatewayError, InvalidParametersError } from '../domain/errors';
import { logger } from '../infrastructure/logger';
export class GetByPostalCode {
    agencyRepository;
    constructor(agencyRepository) {
        this.agencyRepository = agencyRepository;
    }
    async execute(postalCode, brand) {
        if (!this.agencyRepository) {
            throw new AgencyGatewayError('Agency gateway not initialized');
        }
        if (!postalCode || !brand) {
            throw new InvalidParametersError(`Invalid parameters: postal code (${postalCode}) or brand (${brand})`);
        }
        try {
            const agencies = await this.agencyRepository.getByPostalCode(postalCode, brand);
            return agencies ?? [];
        }
        catch (error) {
            logger.error('Failed to fetch agencies by postal code', error);
            return [];
        }
    }
}
export class GetByIds {
    agencyRepository;
    constructor(agencyRepository) {
        this.agencyRepository = agencyRepository;
    }
    async execute(agencyIds, brand) {
        if (!this.agencyRepository) {
            throw new AgencyGatewayError('Agency gateway not initialized');
        }
        if (!agencyIds?.length || !brand) {
            throw new InvalidParametersError(`Invalid parameters: agency IDs (${agencyIds}) or brand (${brand})`);
        }
        try {
            const agencies = await this.agencyRepository.getByIds(agencyIds, brand);
            return agencies ?? [];
        }
        catch (error) {
            logger.error('Failed to fetch agencies by IDs', error);
            return [];
        }
    }
}
export class GetById {
    agencyRepository;
    constructor(agencyRepository) {
        this.agencyRepository = agencyRepository;
    }
    async execute(agencyId, brand, locale) {
        if (!this.agencyRepository) {
            throw new AgencyGatewayError('Agency gateway not initialized');
        }
        if (!agencyId || !brand) {
            throw new InvalidParametersError(`Invalid parameters: agency ID (${agencyId}) or brand (${brand})`);
        }
        try {
            return await this.agencyRepository.getById(agencyId, brand, locale);
        }
        catch (error) {
            logger.error('Failed to fetch agency by ID', error);
            throw new AgencyGatewayError('Failed to fetch agency by ID');
        }
    }
}
